module.exports = __webpack_public_path__ + "static/media/signal-alt-slash.5be0ba22.svg";